import VBtnToggle from './VBtnToggle'

/* istanbul ignore next */
VBtnToggle.install = function install (Vue) {
  Vue.component(VBtnToggle.name, VBtnToggle)
}

export default VBtnToggle



// WEBPACK FOOTER //
// ./src/components/VBtnToggle/index.js